import { Button } from 'react-bootstrap';
import { Link } from "react-router-dom";

function capitalizeFirst(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function ProjectTypeSelector({userName}) {
    return (
        <div className="row">
            <div className="d-flex col-12 col-md-6 flex-column gap-2">
                <h4 className="mb-3">Hello {capitalizeFirst(userName)} Please choose Sovereign or Corporate to start with a new report or pick one from the list of your previous reports. </h4>

                <Link to="/sovereign">
                    <Button variant="outline-dark">Sovereign Analysis</Button>
                </Link>

                <Link to="/corporate">
                    <Button variant="outline-dark">Corporate Analysis</Button>
                </Link>
            </div>
        </div>
    );
}